import { useEffect } from 'react'

import { registerThemeProperty } from '../useAnalytics'
import { useLightMode } from '@/hooks/useLightMode'

/**
 * Keeps the `theme` mixpanel super property in sync with the active theme
 * (ENG-33713), so every event — including the ~115 legacy direct
 * `mixpanel.track` call sites, route-change page views, and window-focus
 * events — carries it without each caller opting in.
 *
 * Renders nothing. Mounted once in `_app.tsx`; it has to live inside the redux
 * `Provider` (unlike `useIdentifyUser` / `useWindowFocusTracking`, which are
 * called from the `_app` body) because `useLightMode` reads the store.
 *
 * This effect runs after the initial page view, which `mixpanel.ts` tracks
 * during module evaluation. That is fine and needs no extra machinery: mixpanel
 * persists super properties in a cookie, and this effect rewrites `theme` on
 * every mount, so the cookie already holds the theme this browser last
 * rendered. The only events that can be off are a browser's first ever page
 * view (no cookie, so no `theme` — absent, not wrong) and the single load after
 * a deploy that changes the effective theme without the app running.
 */
export const ThemeAnalytics = () => {
  const mode = useLightMode()

  useEffect(() => {
    registerThemeProperty(mode)
  }, [mode])

  return null
}
